import styled from '@emotion/styled';
import { Drawer, DrawerProps, IconButton, Typography } from '@material-ui/core';
import { X } from 'lucide-react';
import { FlexContainer } from '../../../../layout/Flex';

const Container = styled('div')<{ noGutter: boolean }>((p) => ({
  padding: p.theme.spacing(p.noGutter ? 0 : 2),
  width: p.theme.spacing(65), // could be made responsive, so that it covers the whole screen at some point
  height: '100%'
}));

export const ScrollableContainer = styled('div')<{
  hasFooter?: boolean;
}>((p) => ({
  display: 'grid',
  gridTemplateRows: p.hasFooter
    ? 'min-content 1fr min-content'
    : 'min-content 1fr',
  rowGap: p.theme.spacing(2),
  height: '100%'
}));

export const ScrollableBody = styled('div')((p) => ({
  overflow: 'auto',
  paddingRight: p.theme.spacing(2),
  marginRight: -p.theme.spacing(2) // place scrollbar at the edge
}));

export const StandardDrawer = ({
  open,
  onClose,
  anchor = 'right',
  variant = 'temporary',
  noGutter,
  children,
  ...other
}: Omit<DrawerProps, 'open' | 'onClose'> & {
  open: boolean;
  onClose: () => void;
  noGutter?: boolean;
}) => {
  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      variant={variant}
      {...other}
    >
      <Container noGutter={!!noGutter}>{children}</Container>
    </Drawer>
  );
};

export const StandardDrawerHeader = ({
  title,
  onClose
}: {
  title: React.ReactNode;
  onClose?: () => void;
}) => {
  return (
    <FlexContainer justifyContent="space-between">
      <Typography variant="h5" component="h5">
        {title}
      </Typography>
      {onClose && (
        <IconButton onClick={onClose}>
          <X size={16} />
        </IconButton>
      )}
    </FlexContainer>
  );
};

export const StandardDrawerContainer = styled('div')((p) => ({
  display: 'grid',
  gridTemplateRows: 'min-content 1fr min-content',
  rowGap: p.theme.spacing(2),
  height: '100%'
}));

export const StandardDrawerBody = styled('div')((p) => ({}));
